/**
 * OpenUI ↔ TaskViews refresh bus
 *
 * Mutations via toolProvider and in-panel creates share one event so the
 * live board reloads without an LLM round-trip.
 */

export const OPENUI_SPACE_TASKS_CHANGED_EVENT = 'openui:space-tasks-changed'

export type OpenUISpaceTasksChangedDetail = {
  spaceId?: string | null
  reason?: 'create' | 'update' | 'refresh'
}

export function dispatchOpenUISpaceTasksChanged(
  detail: OpenUISpaceTasksChangedDetail = {}
) {
  if (typeof window === 'undefined') return
  window.dispatchEvent(
    new CustomEvent<OpenUISpaceTasksChangedDetail>(
      OPENUI_SPACE_TASKS_CHANGED_EVENT,
      { detail }
    )
  )
}
